export const HOME = {
    emergentLink: 'home-emergent-link',
    
    // Navigation
    navHome: 'nav-home-link',
    navStory: 'nav-story-link',
    navServices: 'nav-services-link',
    navAnimals: 'nav-animals-link',
    navReach: 'nav-reach-link',
    navTrust: 'nav-trust-link',
    navFaq: 'nav-faq-link',
    navContact: 'nav-contact-link',
    
    // CTAs - Call & WhatsApp
    navWhatsAppBtn: 'nav-whatsapp-cta-button',
    navCallBtn: 'nav-call-cta-button',
    
    heroWhatsAppBtn: 'hero-whatsapp-cta-button',
    heroCallBtn: 'hero-call-cta-button',
    
    servicesWhatsAppBtn: 'services-whatsapp-cta-button',
    animalsWhatsAppBtn: 'animals-whatsapp-cta-button',
    locationWhatsAppBtn: 'location-whatsapp-cta-button',
    
    contactWhatsAppBtn: 'contact-whatsapp-cta-button',
    contactCallBtn: 'contact-call-cta-button',
    
    floatingWhatsAppBtn: 'floating-whatsapp-widget-button',
    
    // Forms
    formNameInput: 'contact-form-name-input',
    formPhoneInput: 'contact-form-phone-input',
    formAnimalInput: 'contact-form-animal-type-select',
    formMessageInput: 'contact-form-message-textarea',
    formSubmitBtn: 'contact-form-submit-button',
    formSuccessAlert: 'contact-form-success-alert',
    
    // Map links
    googleMapsLink: 'find-us-google-maps-link',
    getDirectionsWhatsApp: 'find-us-get-directions-whatsapp',
    
    // Admin section
    adminLoginBtn: 'admin-dashboard-login-button',
    adminPasscodeInput: 'admin-dashboard-passcode-input',
    adminSubmitBtn: 'admin-dashboard-submit-button',
    adminInquiriesContainer: 'admin-dashboard-inquiries-container',
    adminInquiryCard: 'admin-dashboard-inquiry-card',
    adminCloseBtn: 'admin-dashboard-close-button',
    
    // FAQ triggers
    faqTrigger: (index) => `faq-trigger-${index}`,
    faqContent: (index) => `faq-content-${index}`,
};
